export const DEFAULT_SELECTOR = 'rowId' as const;
